// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: white;
  z-index: 20;
}

.spinner {
  margin: 300px auto;
  width: 100px;
  height: 100px;
  position: relative;
  z-index: 2000;
}

.container1 > div,
.container2 > div,
.container3 > div {
  width: 16px;
  height: 16px;
  border: 5px solid #333;
  background-color: #fff;
  border-radius: 100%;
  position: absolute;
  animation: bouncedelay 1.2s infinite ease-in-out;
  /* Prevent first frame from flickering when animation starts */
  animation-fill-mode: both;
}

.spinner .spinner-container {
  position: absolute;
  width: 100%;
  height: 100%;
}

.container2 {
  transform: rotateZ(45deg);
}

.circle1 {
  top: 0;
  left: 0;
}

.circle2 {
  top: 0;
  right: 0;
}

.circle3 {
  right: 0;
  bottom: 0;
}

.circle4 {
  left: 0;
  bottom: 0;
}

.container2 .circle1 {
  animation-delay: -1.1s;
}

.container1 .circle2 {
  animation-delay: -0.9s;
}

.container2 .circle2 {
  animation-delay: -0.8s;
}

.container1 .circle3 {
  animation-delay: -0.6s;
}

.container2 .circle3 {
  animation-delay: -0.5s;
}

.container1 .circle4 {
  animation-delay: -0.3s;
}

.container2 .circle4 {
  animation-delay: -0.2s;
}
@keyframes bouncedelay {
  0%, 80%, 100% {
    transform: scale(0);
    -webkit-transform: scale(0.25);
  }
  40% {
    transform: scale(1);
    -webkit-transform: scale(1);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/initial-loader/initial-loader.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,iBAAA;EACA,WAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;AACF;;AAEA;;;EAGE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,sBAAA;EAEA,mBAAA;EACA,kBAAA;EAEA,gDAAA;EACA,8DAAA;EAEA,yBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AAAF;;AAGA;EAEE,yBAAA;AAAF;;AAGA;EACE,MAAA;EACA,OAAA;AAAF;;AAGA;EACE,MAAA;EACA,QAAA;AAAF;;AAGA;EACE,QAAA;EACA,SAAA;AAAF;;AAGA;EACE,OAAA;EACA,SAAA;AAAF;;AAGA;EAEE,sBAAA;AAAF;;AAGA;EAEE,sBAAA;AAAF;;AAGA;EAEE,sBAAA;AAAF;;AAGA;EAEE,sBAAA;AAAF;;AAGA;EAEE,sBAAA;AAAF;;AAGA;EAEE,sBAAA;AAAF;;AAGA;EAEE,sBAAA;AAAF;AAeA;EACE;IAGE,mBAAA;IACA,8BAAA;EANF;EASA;IACE,mBAAA;IACA,2BAAA;EAPF;AACF","sourcesContent":[".loading {\n  position: fixed;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  background: white;\n  z-index: 20;\n}\n\n.spinner {\n  margin: 300px auto;\n  width: 100px;\n  height: 100px;\n  position: relative;\n  z-index: 2000;\n}\n\n.container1 > div,\n.container2 > div,\n.container3 > div {\n  width: 16px;\n  height: 16px;\n  border: 5px solid #333;\n  background-color: #fff;\n\n  border-radius: 100%;\n  position: absolute;\n  -webkit-animation: bouncedelay 1.2s infinite ease-in-out;\n  animation: bouncedelay 1.2s infinite ease-in-out;\n  /* Prevent first frame from flickering when animation starts */\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n.spinner .spinner-container {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n\n.container2 {\n  -webkit-transform: rotateZ(45deg);\n  transform: rotateZ(45deg);\n}\n\n.circle1 {\n  top: 0;\n  left: 0;\n}\n\n.circle2 {\n  top: 0;\n  right: 0;\n}\n\n.circle3 {\n  right: 0;\n  bottom: 0;\n}\n\n.circle4 {\n  left: 0;\n  bottom: 0;\n}\n\n.container2 .circle1 {\n  -webkit-animation-delay: -1.1s;\n  animation-delay: -1.1s;\n}\n\n.container1 .circle2 {\n  -webkit-animation-delay: -0.9s;\n  animation-delay: -0.9s;\n}\n\n.container2 .circle2 {\n  -webkit-animation-delay: -0.8s;\n  animation-delay: -0.8s;\n}\n\n.container1 .circle3 {\n  -webkit-animation-delay: -0.6s;\n  animation-delay: -0.6s;\n}\n\n.container2 .circle3 {\n  -webkit-animation-delay: -0.5s;\n  animation-delay: -0.5s;\n}\n\n.container1 .circle4 {\n  -webkit-animation-delay: -0.3s;\n  animation-delay: -0.3s;\n}\n\n.container2 .circle4 {\n  -webkit-animation-delay: -0.2s;\n  animation-delay: -0.2s;\n}\n\n@-webkit-keyframes bouncedelay {\n  0%,\n  80%,\n  100% {\n    -webkit-transform: scale(0.4);\n  }\n\n  40% {\n    -webkit-transform: scale(1);\n  }\n}\n\n@keyframes bouncedelay {\n  0%,\n  80%,\n  100% {\n    transform: scale(0);\n    -webkit-transform: scale(0.25);\n  }\n\n  40% {\n    transform: scale(1);\n    -webkit-transform: scale(1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
